import React from 'react';
import { useSelector } from 'react-redux';
import ChosenOperatorBody from '../ChosenOperatorBody';
import ChosenOperatorHeader from '../ChosenOperatorHeader';
import useTranslation from 'hooks/useTranslation';

const mapState = (state) => ({
  weeklyChosenOperator: state.operatorsData.weeklyChosenOperator,
});

const WeeklyChosenOperator = () => {
  const { weeklyChosenOperator } = useSelector(mapState);
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  return (
    <>
      {weeklyChosenOperator.data && (
        <>
          <div className='operators__list__title'>
            <h2>{t('WEEKLY_CHOSEN_OPERATOR')}</h2>
          </div>
          <div className='operators__list__chosen'>
            <ChosenOperatorHeader />
            <ChosenOperatorBody />
          </div>
        </>
      )}
    </>
  );
};

export default WeeklyChosenOperator;
